/**
 * Created by Alex on 3/8/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { of as observableOf, Observable } from 'rxjs';

import { map, catchError, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { MapTileService } from '../services/maptile.service';
import { CHANGE_MAP_TILE_STATUS, CHANGE_MAP_TILE_STATUS_FAIL, CHANGE_MAP_TILE_STATUS_SUCCESS, PULLING_COORDINATES, PULLING_COORDINATES_FAIL, PULLING_COORDINATES_PROGRESS } from './map-tile.actions';

@Injectable()
export class MapTileEffects {

    constructor(private _actions$: Actions, private _mapTileService: MapTileService) { }

    editMapTileStatusEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CHANGE_MAP_TILE_STATUS),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._mapTileService.editMapTileStatus(payload.enable).pipe(
            map(response => {
                return ({
                    type: CHANGE_MAP_TILE_STATUS_SUCCESS,
                    payload: response
                });
            }),
            catchError(err => {
                return observableOf({ type: CHANGE_MAP_TILE_STATUS_FAIL, payload: err.message });
            }))
        )));

    pullingCoordinateEffects$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(PULLING_COORDINATES),
        map(action => action as any),
        map(action => action.payload),
        switchMap(() => this._mapTileService.getCoordinatesForContactAndEntity().pipe(
            map(response => {
                return ({
                    type: PULLING_COORDINATES_PROGRESS,
                    payload: response
                });

            }),
            catchError(err => {
                return observableOf({ type: PULLING_COORDINATES_FAIL, payload: err.message });
            }))
        )));
}
